import { render, staticRenderFns } from "./AveragePrices.vue?vue&type=template&id=105445da&"
import script from "./AveragePrices.vue?vue&type=script&lang=js&"
export * from "./AveragePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports